<template>
  <span>

    <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
      <span v-show="show_kwartet_info === true" v-if="selected_sickness_id > 0">
        <div class="intro_drawer z_index"></div>
        <span id="game_text_kwartet" class="z_index" v-if="selected_sickness_id !== null" v-html="sicknesses[selected_sickness_id].name"></span>
        <img draggable="false" class="clickable z_index" id="quit_btn_top_drawer" @click="closeDrawer()" src="./../assets/images/Asset 29.png">

        <img draggable="false" v-if="selected_sickness_id !== null" class="card z_index" id="kwartet_card_1" :src="`./images/Asset ${sicknesses[selected_sickness_id].info[0].image_id}.png`">
        <img draggable="false" v-if="selected_sickness_id !== null" class="card z_index" id="kwartet_card_2" :src="`./images/Asset ${sicknesses[selected_sickness_id].info[1].image_id}.png`">
        <img draggable="false" v-if="selected_sickness_id !== null" class="card z_index" id="kwartet_card_3" :src="`./images/Asset ${sicknesses[selected_sickness_id].info[2].image_id}.png`">
        <img draggable="false" v-if="selected_sickness_id !== null" class="card z_index" id="kwartet_card_4" :src="`./images/Asset ${sicknesses[selected_sickness_id].info[3].image_id}.png`">

        <span v-if="selected_sickness_id !== null" class="z_index kwartet_text" v-html="sicknesses[selected_sickness_id].info[0].text" id="kwartet_text_1"></span>
        <span v-if="selected_sickness_id !== null" class="z_index kwartet_text" v-html="sicknesses[selected_sickness_id].info[1].text" id="kwartet_text_2"></span>
        <span v-if="selected_sickness_id !== null" class="z_index kwartet_text" v-html="sicknesses[selected_sickness_id].info[2].text" id="kwartet_text_3"></span>
        <span v-if="selected_sickness_id !== null" class="z_index kwartet_text" v-html="sicknesses[selected_sickness_id].info[3].text" id="kwartet_text_4"></span>
      </span>

      <img draggable="false" class="clickable" id="quit_btn_top" @click="goToHome()" src="./../assets/images/Asset 29.png">
      <img draggable="false" class="background_image" src="./../assets/images/Asset 64.png">
      <img draggable="false" :title="cards[0].name" :class="cards[0].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[0].id)" id="card_1" :src="`./images/Asset ${cards[0].image_id}.png`">
      <img draggable="false" :title="cards[1].name" :class="cards[1].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[1].id)" id="card_2" :src="`./images/Asset ${cards[1].image_id}.png`">
      <img draggable="false" :title="cards[2].name" :class="cards[2].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[2].id)" id="card_3" :src="`./images/Asset ${cards[2].image_id}.png`">
      <img draggable="false" :title="cards[3].name" :class="cards[3].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[3].id)" id="card_4" :src="`./images/Asset ${cards[3].image_id}.png`">
      <img draggable="false" :title="cards[4].name" :class="cards[4].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[4].id)" id="card_5" :src="`./images/Asset ${cards[4].image_id}.png`">
      <img draggable="false" :title="cards[5].name" :class="cards[5].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[5].id)" id="card_6" :src="`./images/Asset ${cards[5].image_id}.png`">
      <img draggable="false" :title="cards[6].name" :class="cards[6].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[6].id)" id="card_7" :src="`./images/Asset ${cards[6].image_id}.png`">
      <img draggable="false" :title="cards[7].name" :class="cards[7].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[7].id)" id="card_8" :src="`./images/Asset ${cards[7].image_id}.png`">
      <img draggable="false" :title="cards[8].name" :class="cards[8].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[8].id)" id="card_9" :src="`./images/Asset ${cards[8].image_id}.png`">
      <img draggable="false" :title="cards[9].name" :class="cards[9].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[9].id)" id="card_10" :src="`./images/Asset ${cards[9].image_id}.png`">
      <img draggable="false" :title="cards[10].name" :class="cards[10].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[10].id)" id="card_11" :src="`./images/Asset ${cards[10].image_id}.png`">
      <img draggable="false" :title="cards[11].name" :class="cards[11].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[11].id)" id="card_12" :src="`./images/Asset ${cards[11].image_id}.png`">
      <img draggable="false" :title="cards[12].name" :class="cards[12].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[12].id)" id="card_13" :src="`./images/Asset ${cards[12].image_id}.png`">
      <img draggable="false" :title="cards[13].name" :class="cards[13].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[13].id)" id="card_14" :src="`./images/Asset ${cards[13].image_id}.png`">
      <img draggable="false" :title="cards[14].name" :class="cards[14].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[14].id)" id="card_15" :src="`./images/Asset ${cards[14].image_id}.png`">
      <img draggable="false" :title="cards[15].name" :class="cards[15].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[15].id)" id="card_16" :src="`./images/Asset ${cards[15].image_id}.png`">
      <img draggable="false" :title="cards[16].name" :class="cards[16].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[16].id)" id="card_17" :src="`./images/Asset ${cards[16].image_id}.png`">
      <img draggable="false" :title="cards[17].name" :class="cards[17].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[17].id)" id="card_18" :src="`./images/Asset ${cards[17].image_id}.png`">
      <img draggable="false" :title="cards[18].name" :class="cards[18].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[18].id)" id="card_19" :src="`./images/Asset ${cards[18].image_id}.png`">
      <img draggable="false" :title="cards[19].name" :class="cards[19].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[19].id)" id="card_20" :src="`./images/Asset ${cards[19].image_id}.png`">
      <img draggable="false" :title="cards[20].name" :class="cards[20].selected ? 'card_selected' : ''" class="card clickable" @click="selectCard(cards[20].id)" id="card_21" :src="`./images/Asset ${cards[20].image_id}.png`">

      <span class="text_label" id="text_label_1" v-html="cards[0].name"></span>
      <span class="text_label" id="text_label_2" v-html="cards[1].name"></span>
      <span class="text_label" id="text_label_3" v-html="cards[2].name"></span>
      <span class="text_label" id="text_label_4" v-html="cards[3].name"></span>
      <span class="text_label" id="text_label_5" v-html="cards[4].name"></span>
      <span class="text_label" id="text_label_6" v-html="cards[5].name"></span>
      <span class="text_label" id="text_label_7" v-html="cards[6].name"></span>
      <span class="text_label" id="text_label_8" v-html="cards[7].name"></span>
      <span class="text_label" id="text_label_9" v-html="cards[8].name"></span>
      <span class="text_label" id="text_label_10" v-html="cards[9].name"></span>
      <span class="text_label" id="text_label_11" v-html="cards[10].name"></span>
      <span class="text_label" id="text_label_12" v-html="cards[11].name"></span>
      <span class="text_label" id="text_label_13" v-html="cards[12].name"></span>
      <span class="text_label" id="text_label_14" v-html="cards[13].name"></span>
      <span class="text_label" id="text_label_15" v-html="cards[14].name"></span>
      <span class="text_label" id="text_label_16" v-html="cards[15].name"></span>
      <span class="text_label" id="text_label_17" v-html="cards[16].name"></span>
      <span class="text_label" id="text_label_18" v-html="cards[17].name"></span>
      <span class="text_label" id="text_label_19" v-html="cards[18].name"></span>
      <span class="text_label" id="text_label_20" v-html="cards[19].name"></span>
      <span class="text_label" id="text_label_21" v-html="cards[20].name"></span>

      <span id="text" v-if="selected_sickness_id == 0" v-html="sicknesses[selected_sickness_id].name"></span>
    </span>
  </span>
</template>

<script>
export default {
  name: "Start",
  mounted() {
    this.randomizeCards()
  },

  created() {},
  destroyed() {},

  data() {
    return {
      kwartet_title: null,
      show_kwartet_info: false,

      cards_disabled: false,
      selected_cards: [],
      selected_sickness_id: null,
      cards: [],
      template_cards: [
        {
          id: 1,
          name: "MAHONIE",
          selected: false,
          image_id: 52,
        },
        {
          id: 2,
          name: "Krubara",
          selected: false,
          image_id: 51,
        },
        {
          id: 3,
          name: "Cacao",
          selected: false,
          image_id: 50,
        },
        {
          id: 4,
          name: "KAKA (FOWRU) KANKAN",
          selected: false,
          image_id: 53,
        },
        {
          id: 5,
          name: "KANKANTRIE",
          selected: false,
          image_id: 57,
        },
        {
          id: 6,
          name: "KUNAME",
          selected: false,
          image_id: 62,
        },
        {
          id: 7,
          name: "LEGUANA OKRO",
          selected: false,
          image_id: 63,
        },
        {
          id: 8,
          name: "RODE LOKUS",
          selected: false,
          image_id: 55,
        },
        {
          id: 9,
          name: "LAAGLAND BABUN",
          selected: false,
          image_id: 58,
        },
        {
          id: 10,
          name: "GROENHART",
          selected: false,
          image_id: 59,
        },
        {
          id: 11,
          name: "DOIFISIRI",
          selected: false,
          image_id: 56,
        },
        {
          id: 12,
          name: "UMA BUSIPAPAYA",
          selected: false,
          image_id: 54,
        },
        {
          id: 13,
          name: "Krerere",
          selected: false,
          image_id: 60,
        },
        {
          id: 14,
          name: "BLAKA UMA",
          selected: false,
          image_id: 61,
        },
        {
          id: 15,
          name: "WALABA",
          selected: false,
          image_id: 70,
        },
        {
          id: 16,
          name: "KOFIMAMA",
          selected: false,
          image_id: 71,
        },
        {
          id: 17,
          name: "REDI KATUN",
          selected: false,
          image_id: 72,
        },
        {
          id: 18,
          name: "BATOTOBITA",
          selected: false,
          image_id: 78,
        },
        {
          id: 19,
          name: "MOPE",
          selected: false,
          image_id: 81,
        },
        {
          id: 20,
          name: "KUSUWÉ",
          selected: false,
          image_id: 85,
        },
        {
          id: 21,
          name: "PODOSIRI",
          selected: false,
          image_id: 84
        },
      ],
      sicknesses: [
        {
          id: 0,
          name: "Probeer opnieuw",
          mixes: [],
          info: []
        },
        {
          id: 1,
          name: "Tandvlees / Mondhygiëne",
          mixes: [13, 20, 4, 9],
          info: [
            {
              id: 9,
              text: 'Virola Surinamensis behoort tot de familie Myristicaceae. De schors wordt gebruikt in een mondspoeling om tandabces te behandelen.',
              image_id: 58,
            },
            {
              id: 4,
              text: 'Heliotropium indicum behoort tot de familie Boraginaceae. De bladeren worden tot poeder vermalen en vervolgens als remedie geplaatst op het geïnfecteerd tandvlees.',
              image_id: 53,
            },
            {
              id: 20,
              text: 'Bixa orellana van de familie Bixaceae. Een afkooksel van de wortels wordt gegorgeld en als een remedie tegen mond- en keelinfecties.',
              image_id: 85,
            },
            {
              id: 13,
              text: 'Caesalpinia pulcherrima van de familie Fabaceae. Afhankelijk van de dosering wordt een afkooksel van wortels, schors, bladeren en/of bloemen gebruikt als mondwater voor tanden of tandvlees.',
              image_id: 60,
            },
          ]
        },
        {
          id: 2,
          name: "Spierpijnen",
          mixes: [11, 12, 20, 8],
          info: [
            {
              id: 11,
              text: 'Guarea guidonia behoort tot de familie Meliaceae. De vloeistof verkregen uit de geraspte schors wordt op de huid gewreven om lichaamspijnen te verlichten.',
              image_id: 56,
            },
            {
              id: 8,
              text: 'Hymenaea courbaril behoort tot de familie Fabaceae. Een  thee wordt gemaakt van de schors en wordt gebruikt tegen rugpijn.',
              image_id: 55,
            },
            {
              id: 12,
              text: 'Cecropia peltata behoort tot de familie Urticaceae. Er wordt een thee bereid uit de gedroogde bladeren en gebruikt tegen rugpijn.',
              image_id: 54,
            },
            {
              id: 20,
              text: 'Bixa orellana van de familie Bixaceae. De bladeren kunnen worden gebruikt bij het baden om spierpijn te verlichten.',
              image_id: 85,
            },
          ]
        },
        {
          id: 3,
          name: "Hoesten",
          mixes: [ 10, 5, 7, 9],
          info: [
            {
              id: 10,
              text: 'Handroanthus serratifolius behoort tot de familie Bignoniaceae. Een afkooksel van de plant gecombineerd met honing wordt genuttigd om hoesten te verlichten.',
              image_id: 59,
            },
            {
              id: 7,
              text: 'De Hibiscus bifurcatus stamt af van de familie Malvaceae. De bladeren worden gezet in heet water  welke na afkoeling wordt gedronken tegen Hoesten.',
              image_id: 63,
            },
            {
              id: 9,
              text: 'Virola Surinamensis behoort tot de familie Myristicaceae. De takken worden geraspt en gedronken in een afkooksel om het hoesten te verlichten.',
              image_id: 58,
            },
            {
              id: 5,
              text: 'Ceiba pentandra behoort tot de familie Malvaceae. Van de bladeren wordt een afkoosel gemaakt en gedronken tegen Hoest.',
              image_id: 57,
            },
          ]
        },
        {
          id: 4,
          name: "Verkoudheid",
          mixes: [13, 14, 6, 7],
          info: [
            {
              id: 7,
              text: 'De Hibiscus bifurcatus stamt af van de familie Malvaceae. De bladeren worden gezet in heet water  welke na afkoeling wordt gedronken tegen verkoudheid.',
              image_id: 63,
            },
            {
              id: 6,
              text: 'De Clibadium surinamensis is deel van de  familie Asteraceae. De hele plant, gecombineerd met Lippia alba en Wedelia trilobata, wordt met name ingewreven  op het hoofd en de borstkas als remedie tegen verkoudheid.',
              image_id: 62,
            },
            {
              id: 14,
              text: 'De Cordia curassavica is familie van de Boraginaceae. De bladeren in heet water plaatsen en een stoombad nemen bij de behandeling van erge verkoudheid',
              image_id: 61,
            },
            {
              id: 13,
              text: 'Caesalpinia pulcherrima van de familie Fabaceae. Afhankelijk van de dosering wordt een afkooksel van wortels, schors, bladeren en/of bloemen gebruikt als een remedie tegen verkoudheid.',
              image_id: 60,
            },
          ]
        },
        {
          id: 5,
          name: "Open wonden, schaaf en snij wonden",
          mixes: [12, 15, 16, 2],
          info: [
            {
              id: 2,
              text: 'Pentaclethra macroloba behoort tot de familie Fabaceae, waarvan de schors gebruikt wordt als een was op snijwonden.',
              image_id: 51,
            },
            {
              id: 12,
              text: 'De Cecropia peltata behoort tot de familie Urticaceae. Van de jonge scheuten wordt een hete kompres gemaakt en gebruikt als verband voor wonden en snijwonden.',
              image_id: 54,
            },
            {
              id: 16,
              text: 'Erythrina fusca behoort tot de familie Fabaceae. De schors ervan wordt gebonden op verse wonden.',
              image_id: 71,
            },
            {
              id: 15,
              text: 'Eperua falcata behoort tot de familie Fabaceae. De hars van de schors wordt op warm gemaakte  bladeren geplaatst en rond de snijwonden gebonden.',
              image_id: 70,
            },
          ]
        },
        {
          id: 6,
          name: "Maagklachten/buikpijn",
          mixes: [17, 19, 5, 8],
          info: [
          {
              id: 8,
              text: 'Hymenaea courbaril behoort tot de familie Fabaceae. Een thee wordt  getrokken van de schors. Deze thee wordt gebruikt om maagproblemen te verlichten.',
              image_id: 55,
            },
            {
              id: 5,
              text: 'Ceiba pentandra behoort tot de familie Malvaceae. De stam-schors wordt gekookt in water en daarna gedronken om maagklachten te verlichten.',
              image_id: 57,
            },
            {
              id: 19,
              text: 'Spondias mombin van de familie Anacardiaceae. De bast  wordt gebruikt om thee van te trekken en te drinken als remedie tegen buikpijn.',
              image_id: 81,
            },
            {
              id: 17,
              text: 'Gossypium barbadense van de familie Malvaceae. Er wordt thee van de bladeren getrokken. Deze thee wordt gebruikt voor de behandeling van buikpijn.',
              image_id: 72,
            },
          ]
        },
        {
          id: 7,
          name: "Koorts",
          mixes: [13, 18, 20, 21],
          info: [
            {
              id: 20,
              text: 'De Bixa orellana is familie van de Bixaceae. De bladeren worden in een teil met warm water gezet, om daarna over de persoon heen te gieten. Dit wordt gebruikt om koorts te verlagen.',
              image_id: 85,
            },
            {
              id: 13,
              text: 'Caesalpinia pulcherrima van de familie Fabaceae. Van de wortels, schors en bladeren samen wordt thee getrokken. Dit wordt gedronken tegen koorts.',
              image_id: 60,
            },
            {
              id: 18,
              text: 'De Physalis angulata behoort tot de familie Solanaceae. De bladeren worden toegevoegd aan  palmwijn en vervolgens gedronken om koorts te genezen.',
              image_id: 78,
            },
            {
              id: 21,
              text: 'De Euterpe oleracea maakt deel uit van de familie Arecaceae. Van de zaden wordt een thee getrokken en ingenomen om koorts te behandelen.',
              image_id: 84
            },
          ]
        },
        {
          id: 8,
          name: "Diaree",
          mixes: [1, 2, 3, 8],
          info: [
            {
              id: 8,
              text: 'De Hymenaea courbaril behoort tot de familie Fabaceae. De schors moet eerst  weken  in een koude vloeistof en wordt daarna ingenomen tegen diarree.',
              image_id: 55,
            },
            {
              id: 1,
              text: 'De Swietenia mahagoni  behoort tot de familie Meliaceae. De schors van de stam wordt eerst in water uitgekookt en deze afkooksel wordt daarna gedronken als medicijn tegen diarree.',
              image_id: 52,
            },
            {
              id: 2,
              text: 'De Pentaclethra macroloba behoort tot de familie Fabaceae. De schors van de boom wordt gekookt in water en dit water (afkooksel) wordt gedronken tegen diarree.',
              image_id: 51,
            },
            {
              id: 3,
              text: 'De Theobroma cacao van de familie Malvaceae, hiervan worden de zaadjes gegeten en gebruikt tegen diarree.',
              image_id: 50,
            },
          ]
        },
      ],
    };
  },

  methods: {
    closeDrawer() {
      this.show_kwartet_info = false
      this.selected_sickness_id = null
    },

    showDrawer() {
      this.show_kwartet_info = true
    },

    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    randomizeCards() {
      let arr = this.shuffle(this.template_cards);
      this.cards = arr;
    },
    shuffle(array) {
      let currentIndex = array.length,  randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex > 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
    goToGamePage() {
      this.$router.push('/game');
    },
    GoToPhagwaGame() {
      this.$router.push('/phagwagame');
    },
    GoToKerstmisGame() {
      this.$router.push('/kerstmisgame');
    },
    checkMixes() {
      let selected_cards = this.selected_cards.sort(),
          that = this

      for (let index = 0; index < this.sicknesses.length; index++) {
        if ( this.compareArrays(selected_cards, this.sicknesses[index].mixes) ) {
          this.selected_sickness_id = index

          this.showDrawer()

          break;
        } else {
          this.selected_sickness_id = 0

          if ( this.selected_sickness_id ) {
            setTimeout(function() {
              that.selected_sickness_id = null
            }, 7000)
          }
          
        }
      }
    },
    selectCard(id) {
      let cards = this.cards

      for (let index = 0; index < cards.length; index++) {
        var that = this
        if ( cards[index].id == id && ! this.cards_disabled ) {
          cards[index].selected = ! cards[index].selected

          if ( cards[index].selected ) {
            this.selected_cards.push(id);
          } else {
            this.removeSelectedCard(id)
          }

          if ( this.selected_cards.length >= 4 ) {
            this.checkMixes()
            this.cards_disabled = true

            setTimeout(function() {
              that.cards_disabled = false
              that.closeAllCards()
              that.selected_cards = []
            }, 1500)
          }
        }
      }

      this.cards = cards
    },

    compareArrays(arrfirst, arrsecond) {
      if (arrfirst.length !== arrsecond.length) {
        return false;
      }
      return arrfirst.every((value, index) => value === arrsecond[index]);
    },

    removeSelectedCard(id) {
      let selected_cards = this.selected_cards,
          filtered_cards = []

      for (let index = 0; index < selected_cards.length; index++) {
        if ( selected_cards[index] == id ) {
          filtered_cards = selected_cards.filter(function(selected_card) {
            return selected_card !== id
          })
        }
      }

      this.selected_cards = filtered_cards
    },

    closeAllCards() {
      let cards = this.cards

      for (let index = 0; index < cards.length; index++)
        cards[index].selected = false

      this.cards = cards
    }
  },

  computed: {}
};
</script>

<style>
  #game_text_kwartet {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 60%;
    left: 20%;
    color: white;
    font-size: 4vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
}

  #kwartet_card_1 {
    position: absolute;
    margin-top: 11%;
    left: 8%;
    width: 15%;
  }
  #kwartet_card_2 {
    position: absolute;
    margin-top: 11%;
    left: 31%;
    width: 15%;
  }
  #kwartet_card_3 {
    position: absolute;
    margin-top: 11%;
    left: 54%;
    width: 15%;
  }
  #kwartet_card_4 {
    position: absolute;
    margin-top: 11%;
    left: 77%;
    width: 15%;
  }

  .kwartet_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    width: 20%;
    color: white;
    font-size: 1.6vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
    margin-top: 32%;
  }
  #kwartet_text_1 {
    left: 6%;
  }
  #kwartet_text_2 {
    left: 29%;
  }
  #kwartet_text_3 {
    left: 52%;
  }
  #kwartet_text_4 {
    left: 75%;
  }

  #text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 48%;
    width: 92%;
    left: 4%;
    color: white;
    font-size: 5vw;
    text-align: center;
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
  }

  #quit_btn_top {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  #quit_btn_top_drawer {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
  }

  .card {
    position: absolute;
    width: 7%;
    -webkit-filter: drop-shadow(5px 5px 5px black);
    filter: drop-shadow(5px 5px 5px black);
  }

  .card_selected {
    border-style: solid;
    border-color: brown;
    border-width: 5px;
  }

  #card_1 {
    margin-top: 11%;
    left: 2%;
  }
  #card_2 {
    margin-top: 11%;
    left: 11%;
  }
  #card_3 {
    margin-top: 11%;
    left: 20%;
  }
  #card_4 {
    margin-top: 11%;
    left: 29%;
  }
  #card_5 {
    margin-top: 11%;
    left: 38%;
  }
  #card_6 {
    margin-top: 11%;
    left: 47%;
  }

  #card_7 {
    margin-top: 11%;
    left: 56%;
  }

  #card_8 {
    margin-top: 11%;
    left: 65%;
  }
  #card_9 {
    margin-top: 11%;
    left: 74%;
  }
  #card_10 {
    margin-top: 11%;
    left: 83%;
  }
  #card_11 {
    margin-top: 11%;
    left: 91%;
  }
  #card_12 {
    margin-top: 28%;
    left: 2%;
  }
  #card_13 {
    margin-top: 28%;
    left: 11%;
  }
  #card_14 {
    margin-top: 28%;
    left: 20%;
  }
  #card_15 {
    margin-top: 28%;
    left: 29%;
  }
  #card_16 {
    margin-top: 28%;
    left: 38%;
  }
  #card_17 {
    margin-top: 28%;
    left: 47%;
  }
  #card_18 {
    margin-top: 28%;
    left: 56%;
  }
  #card_19 {
    margin-top: 28%;
    left: 65%;
  }
  #card_20 {
    margin-top: 28%;
    left: 74%;
  }
  #card_21 {
    margin-top: 28%;
    left: 83%;
  }

  .text_label {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 22%;
    color: white;
    font-size: 1.1vw;
    text-align: center;
    width: 7%;
  }

  #text_label_1 {
    left: 2%;
  }
  #text_label_2 {
    left: 11%;
  }
  #text_label_3 {
    left: 20%;
  }
  #text_label_4 {
    left: 29%;
  }
  #text_label_5 {
    left: 38%;
  }
  #text_label_6 {
    left: 47%;
  }
  #text_label_7 {
    left: 56%;
  }
  #text_label_8 {
    left: 65%;
  }
  #text_label_9 {
    left: 74%;
  }
  #text_label_10 {
    left: 83%;
  }
  #text_label_11 {
    left: 91%;
  }
  #text_label_12 {
    margin-top: 38%;
    left: 2%;
  }
  #text_label_13 {
    margin-top: 38%;
    left: 11%;
  }
  #text_label_14 {
    margin-top: 38%;
    left: 20%;
  }
  #text_label_15 {
    margin-top: 38%;
    left: 29%;
  }
  #text_label_16 {
    margin-top: 38%;
    left: 38%;
  }
  #text_label_17 {
    margin-top: 38%;
    left: 47%;
  }
  #text_label_18 {
    margin-top: 38%;
    left: 56%;
  }
  #text_label_19 {
    margin-top: 38%;
    left: 65%;
  }
  #text_label_20 {
    margin-top: 38%;
    left: 74%;
  }
  #text_label_21 {
    margin-top: 38%;
    left: 83%;
  }
</style>


